import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiEye, FiEyeOff, FiUser, FiLock, FiMail, FiCheck } from 'react-icons/fi';
import './LoginDemo.css';

const LoginDemo = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    terms: false
  });
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Limpar erro quando o usuário começar a digitar
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.username.trim()) {
      newErrors.username = 'Nome de usuário é obrigatório';
    }

    if (!isLogin && !formData.email.trim()) {
      newErrors.email = 'Email é obrigatório';
    } else if (!isLogin && formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email inválido';
    }

    if (!formData.password) {
      newErrors.password = 'Senha é obrigatória';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Senha deve ter pelo menos 6 caracteres';
    }

    if (!isLogin && formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Senhas não coincidem';
    }

    if (!formData.terms) {
      newErrors.terms = 'Você deve aceitar os termos';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      // Simular sucesso
      alert(isLogin ? 'Login realizado com sucesso!' : 'Cadastro realizado com sucesso!');
      console.log('Form data:', formData);
    }
  };

  const toggleForm = () => {
    setIsLogin(!isLogin);
    setFormData({
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
      terms: false
    });
    setErrors({});
    setShowPassword(false);
    setShowConfirmPassword(false);
  };

  const formVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.3 }
    },
    exit: { 
      opacity: 0, 
      x: 20,
      transition: { duration: 0.2 }
    }
  };

  return (
    <div className="login-demo">
      <div className="login-demo__container">
        <div className="login-demo__header">
          <h3>Demonstração Interativa</h3>
          <p>Teste a funcionalidade da página de login</p>
        </div>

        <div className="login-demo__form-container">
          <div className="login-demo__tabs">
            <button
              className={`login-demo__tab ${isLogin ? 'active' : ''}`}
              onClick={() => setIsLogin(true)}
            >
              Login
            </button>
            <button
              className={`login-demo__tab ${!isLogin ? 'active' : ''}`}
              onClick={() => setIsLogin(false)}
            >
              Cadastro
            </button>
          </div>

          <AnimatePresence mode="wait">
            <motion.form
              key={isLogin ? 'login' : 'register'}
              className="login-demo__form"
              variants={formVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              onSubmit={handleSubmit}
            >
              <div className="login-demo__form-group">
                <div className="login-demo__input-wrapper">
                  <FiUser className="login-demo__input-icon" />
                  <input
                    type="text"
                    name="username"
                    placeholder="Nome de usuário"
                    value={formData.username}
                    onChange={handleInputChange}
                    className={errors.username ? 'error' : ''}
                  />
                </div>
                {errors.username && (
                  <span className="login-demo__error">{errors.username}</span>
                )}
              </div>

              {!isLogin && (
                <div className="login-demo__form-group">
                  <div className="login-demo__input-wrapper">
                    <FiMail className="login-demo__input-icon" />
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className={errors.email ? 'error' : ''}
                    />
                  </div>
                  {errors.email && (
                    <span className="login-demo__error">{errors.email}</span>
                  )}
                </div>
              )}

              <div className="login-demo__form-group">
                <div className="login-demo__input-wrapper">
                  <FiLock className="login-demo__input-icon" />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    placeholder="Senha"
                    value={formData.password}
                    onChange={handleInputChange}
                    className={errors.password ? 'error' : ''}
                  />
                  <button
                    type="button"
                    className="login-demo__toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
                {errors.password && (
                  <span className="login-demo__error">{errors.password}</span>
                )}
              </div>

              {!isLogin && (
                <div className="login-demo__form-group">
                  <div className="login-demo__input-wrapper">
                    <FiLock className="login-demo__input-icon" />
                    <input
                      type={showConfirmPassword ? 'text' : 'password'}
                      name="confirmPassword"
                      placeholder="Confirmar senha"
                      value={formData.confirmPassword}
                      onChange={handleInputChange}
                      className={errors.confirmPassword ? 'error' : ''}
                    />
                    <button
                      type="button"
                      className="login-demo__toggle-password"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                      {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                    </button>
                  </div>
                  {errors.confirmPassword && (
                    <span className="login-demo__error">{errors.confirmPassword}</span>
                  )}
                </div>
              )}

              <div className="login-demo__form-group">
                <label className="login-demo__checkbox">
                  <input
                    type="checkbox"
                    name="terms"
                    checked={formData.terms}
                    onChange={handleInputChange}
                  />
                  <span className="login-demo__checkmark">
                    <FiCheck />
                  </span>
                  <span className="login-demo__checkbox-text">
                    Aceito os termos e condições
                  </span>
                </label>
                {errors.terms && (
                  <span className="login-demo__error">{errors.terms}</span>
                )}
              </div>

              <button type="submit" className="login-demo__submit">
                {isLogin ? 'Entrar' : 'Cadastrar'}
              </button>

              <div className="login-demo__toggle">
                <span>
                  {isLogin ? 'Não tem uma conta?' : 'Já tem uma conta?'}
                </span>
                <button
                  type="button"
                  className="login-demo__toggle-btn"
                  onClick={toggleForm}
                >
                  {isLogin ? 'Cadastre-se' : 'Faça login'}
                </button>
              </div>
            </motion.form>
          </AnimatePresence>
        </div>

        <div className="login-demo__features">
          <h4>Funcionalidades implementadas:</h4>
          <ul>
            <li>✅ Validação de formulário em tempo real</li>
            <li>✅ Alternância entre login e cadastro</li>
            <li>✅ Mostrar/ocultar senha</li>
            <li>✅ Feedback visual de erros</li>
            <li>✅ Design responsivo</li>
            <li>✅ Animações suaves</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LoginDemo;